var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftArrowC = function SvgLeftArrowC(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.318.216 5.411 5.12c.172.163.271.4.271.65s-.099.487-.271.65l-5.41 5.115a.722.722 0 0 1-.784.208.834.834 0 0 1-.525-.676.897.897 0 0 1 .305-.824l4.726-4.472L.315 1.513a.912.912 0 0 1-.23-.968C.205.2.513-.018.846 0c.175.01.341.086.472.215Z",
    fill: "#212121",
    fillRule: "nonzero"
  })));
};
export default SvgLeftArrowC;